module.exports = __webpack_public_path__ + "static/media/13_potolok_5.36_0.68defbdb.png";